import IconButton from '@mui/material/IconButton';
import styled from '@mui/material/styles/styled';

export const M3IconButtonBase = styled(IconButton)`
  width: 40px;
  height: 40px;
  color: var(--md-sys-color-on-surface-light);

  &.active,
  &:hover {
    background-color: var(--md-sys-color-surface-variant-light);
  }

  &.dark-mode-button {
    color: var(--md-sys-color-on-surface-dark);

    &.active,
    &:hover {
      background-color: var(--md-sys-color-surface-variant-dark);
    }
  }

  &.m3-icon-button-back-detail-button {
    margin-left: -5px;
  }
`;
